export {default} from "../patterngalleries/Newest";



// WEBPACK FOOTER //
// ./src/components/async/PatterngalleryNewest.js